// src/modules/app-views/toolbox/pages/Document/components/ToolboxDocumentCardHeaderColumn2.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleColumn from 'components/SimpleComponents/SimpleColumn';
import { StarOutlined } from '@ant-design/icons';
import { parseDateToDisplay } from 'utils/helpers';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const ToolboxDocumentCardHeaderColumn2 = ({
  showCreatedAt = true,
  ...record
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const createdAt =
    (record?._metadata?.audit?.createdAt &&
      parseDateToDisplay({ date: record._metadata.audit.createdAt })) ||
    (record?.createdAt && parseDateToDisplay({ date: record.createdAt }));

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const items = [
    {
      key: 'createdAt',
      icon: <StarOutlined />,
      label: createdAt,
      tooltipText: translateX('creation_date'),
      tooltipPlacement: 'right',
      onClick: null,
      hidden: !showCreatedAt,
    },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <SimpleColumn items={items?.filter(i => i?.label && !i.hidden)} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ToolboxDocumentCardHeaderColumn2;

// *******************************************************************************
// HELPERS
// *******************************************************************************
